import React from 'react';
import { getExtraLabel } from '../labelGetters';

export default function ExtraDisplay({ extra, labels, isNew = false }) {
  const extraId = extra.extraId || extra.id;
  const displayName = getExtraLabel(extraId, labels) || `Extra #${extraId}`;
  const borderClass = isNew ? 'border-green-300' : 'border-gray-200';

  return (
    <div
      className={`flex items-center gap-2 p-2 bg-gray-50 rounded border ${borderClass}`}
    >
      <i className="fa-regular fa-puzzle-piece text-blue-500" />
      <span className="text-sm text-gray-700">{displayName}</span>
    </div>
  );
}
